import { RootState } from 'src/state/types';

export const getAccessToken = (state: RootState): string | undefined => state.auth.authToken?.access_token;

export const selectIsAuthenticating = (state: RootState): boolean => state.auth.authenticating;

export const selectIsAuthenticated = (state: RootState): boolean => !!getAccessToken(state);

export const selectAuthFailed = (state: RootState): boolean => state.auth.failed;
